(function(){
  function q(s,r){return (r||document).querySelector(s);}
  function qa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}

  function requestedVendor(){
    try {
      return new URL(window.location.href).searchParams.get('st_vendor') || '';
    } catch(e) {
      return '';
    }
  }

  function addVendorToForm(form){
    var vendor=requestedVendor();
    if(!form||!vendor)return;
    var existing=q('input[name="st_vendor"]',form);
    if(existing){
      existing.value=vendor;
      return;
    }
    var hidden=document.createElement('input');
    hidden.type='hidden';
    hidden.name='st_vendor';
    hidden.value=vendor;
    form.appendChild(hidden);
  }

  async function hydrateDrawerIfNeeded(drawer){
    var vendor=requestedVendor();
    if(!vendor||!drawer)return;

    var body=q('.st-native-drawer-body',drawer);
    var hasSections=body && q('.st-native-filter-section',body);

    /* If Shopify returned a complete drawer already, only preserve st_vendor. */
    if(hasSections){
      addVendorToForm(q('#st-native-filter-form',drawer));
      return;
    }

    try{
      var cleanUrl=new URL(window.location.href);
      cleanUrl.searchParams.delete('st_vendor');
      cleanUrl.searchParams.delete('page');

      var res=await fetch(cleanUrl.toString(),{
        credentials:'same-origin',
        headers:{'X-Requested-With':'XMLHttpRequest'}
      });
      if(!res.ok)return;

      var html=await res.text();
      var doc=new DOMParser().parseFromString(html,'text/html');
      var fresh=q('#st-native-filter-drawer',doc);
      if(!fresh)return;

      drawer.innerHTML=fresh.innerHTML;
      addVendorToForm(q('#st-native-filter-form',drawer));
    }catch(e){
      console.error('[STYLISHTOP] Filter drawer hydration failed:',e);
    }
  }

  function init(){
    var open=q('#st-native-filter-open'),
        drawer=q('#st-native-filter-drawer'),
        overlay=q('#st-native-filter-overlay');

    if(!open||!drawer||!overlay)return;

    function show(){
      var body=q('.st-native-drawer-body',drawer);
      if(body) body.scrollTop=0;

      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden','false');
      open.setAttribute('aria-expanded','true');
      document.body.classList.add('st-native-filter-open');
    }

    function hide(){
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      open.setAttribute('aria-expanded','false');
      document.body.classList.remove('st-native-filter-open');
    }

    open.addEventListener('click',async function(e){
      e.preventDefault();
      await hydrateDrawerIfNeeded(drawer);
      show();
    });

    /* Delegate events so controls still work after drawer hydration/replacement. */
    drawer.addEventListener('click',function(e){
      var close=e.target.closest && e.target.closest('#st-native-filter-close');
      if(close){
        e.preventDefault();
        hide();
        return;
      }

      var heading=e.target.closest && e.target.closest('.st-native-filter-heading');
      if(heading && drawer.contains(heading)){
        e.preventDefault();
        var section=heading.closest('.st-native-filter-section');
        if(!section)return;
        var collapsed=section.classList.toggle('is-collapsed');
        heading.setAttribute('aria-expanded',collapsed?'false':'true');
      }
    });

    drawer.addEventListener('submit',function(){
      addVendorToForm(q('#st-native-filter-form',drawer));
    });

    overlay.addEventListener('click',hide);
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape')hide();
    });

    /* Pre-hydrate in the background so the first open is instant. */
    if(requestedVendor()){
      setTimeout(function(){hydrateDrawerIfNeeded(drawer);},0);
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  }else{
    init();
  }
})();